import { getContrastRatio } from './colorAnalysis';

export type LinkUnderline = 'always' | 'interaction' | 'none';
export interface LinkColors { link: string; text: string; bg: string; underline: LinkUnderline }
export const DEFAULT_LINK_COLORS: LinkColors = { link: '#2563EB', text: '#111827', bg: '#FFFFFF', underline: 'always' };

export function parseLinkColors(search: string): LinkColors {
  const params = new URLSearchParams(search);
  const color = (key: 'link' | 'text' | 'bg') => {
    const value = (params.get(key) || '').replace(/^#/, '');
    return /^[0-9a-f]{6}$/i.test(value) ? '#' + value.toUpperCase() : DEFAULT_LINK_COLORS[key];
  };
  const underline = params.get('underline');
  return { link: color('link'), text: color('text'), bg: color('bg'), underline: underline === 'none' || underline === 'interaction' ? underline : 'always' };
}

export function linkColorsPath(colors: LinkColors): string {
  const query = new URLSearchParams({ link: colors.link.replace('#', ''), text: colors.text.replace('#', ''), bg: colors.bg.replace('#', ''), underline: colors.underline });
  return '/link-contrast-checker?' + query.toString();
}

export function checkLinkColors(colors: LinkColors) {
  const linkOnBackground = getContrastRatio(colors.link, colors.bg);
  const bodyOnBackground = getContrastRatio(colors.text, colors.bg);
  const linkAgainstBody = getContrastRatio(colors.link, colors.text);
  const distinctionRequired = colors.underline !== 'always';
  return {
    linkOnBackground, bodyOnBackground, linkAgainstBody, distinctionRequired,
    linkPass: linkOnBackground >= 4.5,
    bodyPass: bodyOnBackground >= 4.5,
    distinctionPass: !distinctionRequired || linkAgainstBody >= 3,
    selectedChecksPass: linkOnBackground >= 4.5 && bodyOnBackground >= 4.5 && (!distinctionRequired || linkAgainstBody >= 3),
  };
}
